'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/beginningOfMonth.js
// module id = 254
// module chunks = 0